import LinkButton from '@standardsdigital/ui-components/LinkButton';
import { useTranslation } from 'react-i18next';
import styles from './NotLoggedInMessage.module.css';

function NotLoggedInMessage() {
  const { t } = useTranslation();

  return (
    <section className={styles.pageWrapper}>
      <h1 className="sd-heading-xl">{t('authentication.pleaseLogIn')}</h1>
      <p className={`sd-body-xl ${styles.notLoggedInMessage}`}>
        {t('authentication.notLoggedInMessage')}
      </p>
      <LinkButton variant="primary" href="/bff/login">
        {t('authentication.logIn')}
      </LinkButton>
    </section>
  );
}

export default NotLoggedInMessage;
